import type { DiyRecipeIngredient } from '../types';

export function formatIngredient(ingredient: DiyRecipeIngredient) {
  const { quantity, name, unit } = ingredient;
  return `${quantity} ${unit} ${name}`;
}
